/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * PaymentRuleApi - axios parameter creator
 * @export
 */
export const PaymentRuleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create new payment rule
         * @param {CreatePaymentRuleDto} createPaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerCreate: (createPaymentRuleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPaymentRuleDto' is not null or undefined
            assertParamExists('paymentRuleControllerCreate', 'createPaymentRuleDto', createPaymentRuleDto);
            const localVarPath = `/payment-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentRuleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all payment rule for a bank account.
         * @param {string} workspaceId
         * @param {string} bankDetailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindAll: (workspaceId, bankDetailsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('paymentRuleControllerFindAll', 'workspaceId', workspaceId);
            // verify required parameter 'bankDetailsId' is not null or undefined
            assertParamExists('paymentRuleControllerFindAll', 'bankDetailsId', bankDetailsId);
            const localVarPath = `/payment-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (bankDetailsId !== undefined) {
                localVarQueryParameter['bankDetailsId'] = bankDetailsId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentRuleControllerFindOne', 'id', id);
            const localVarPath = `/payment-rule/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentRuleControllerRemove', 'id', id);
            const localVarPath = `/payment-rule/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRuleDto} updatePaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerUpdate: (id, updatePaymentRuleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentRuleControllerUpdate', 'id', id);
            // verify required parameter 'updatePaymentRuleDto' is not null or undefined
            assertParamExists('paymentRuleControllerUpdate', 'updatePaymentRuleDto', updatePaymentRuleDto);
            const localVarPath = `/payment-rule/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentRuleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentRuleApi - functional programming interface
 * @export
 */
export const PaymentRuleApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentRuleApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create new payment rule
         * @param {CreatePaymentRuleDto} createPaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerCreate(createPaymentRuleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentRuleControllerCreate(createPaymentRuleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all payment rule for a bank account.
         * @param {string} workspaceId
         * @param {string} bankDetailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindAll(workspaceId, bankDetailsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentRuleControllerFindAll(workspaceId, bankDetailsId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentRuleControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentRuleControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRuleDto} updatePaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerUpdate(id, updatePaymentRuleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentRuleControllerUpdate(id, updatePaymentRuleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentRuleApi - factory interface
 * @export
 */
export const PaymentRuleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentRuleApiFp(configuration);
    return {
        /**
         *
         * @summary Create new payment rule
         * @param {CreatePaymentRuleDto} createPaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerCreate(createPaymentRuleDto, options) {
            return localVarFp
                .paymentRuleControllerCreate(createPaymentRuleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all payment rule for a bank account.
         * @param {string} workspaceId
         * @param {string} bankDetailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindAll(workspaceId, bankDetailsId, options) {
            return localVarFp
                .paymentRuleControllerFindAll(workspaceId, bankDetailsId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerFindOne(id, options) {
            return localVarFp
                .paymentRuleControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerRemove(id, options) {
            return localVarFp
                .paymentRuleControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdatePaymentRuleDto} updatePaymentRuleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentRuleControllerUpdate(id, updatePaymentRuleDto, options) {
            return localVarFp
                .paymentRuleControllerUpdate(id, updatePaymentRuleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentRuleApi - object-oriented interface
 * @export
 * @class PaymentRuleApi
 * @extends {BaseAPI}
 */
export class PaymentRuleApi extends BaseAPI {
    /**
     *
     * @summary Create new payment rule
     * @param {CreatePaymentRuleDto} createPaymentRuleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRuleApi
     */
    paymentRuleControllerCreate(createPaymentRuleDto, options) {
        return PaymentRuleApiFp(this.configuration)
            .paymentRuleControllerCreate(createPaymentRuleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all payment rule for a bank account.
     * @param {string} workspaceId
     * @param {string} bankDetailsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRuleApi
     */
    paymentRuleControllerFindAll(workspaceId, bankDetailsId, options) {
        return PaymentRuleApiFp(this.configuration)
            .paymentRuleControllerFindAll(workspaceId, bankDetailsId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRuleApi
     */
    paymentRuleControllerFindOne(id, options) {
        return PaymentRuleApiFp(this.configuration)
            .paymentRuleControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRuleApi
     */
    paymentRuleControllerRemove(id, options) {
        return PaymentRuleApiFp(this.configuration)
            .paymentRuleControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {UpdatePaymentRuleDto} updatePaymentRuleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRuleApi
     */
    paymentRuleControllerUpdate(id, updatePaymentRuleDto, options) {
        return PaymentRuleApiFp(this.configuration)
            .paymentRuleControllerUpdate(id, updatePaymentRuleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
